import { EmporiumNav } from '../../components/EmporiumNav';
import { Colophon } from '../../components/Colophon';
import { SectionHeading, Eyebrow } from '../../primitives';
import { LINKS } from '../../brand';
import { withBase } from '../../paths';
import { versionedUrl } from '../../utils/versionedUrl';

/**
 * Terminal page for the MCP authorization flow (SEC-0006 / prompt §8). The user lands here after
 * approving the authorization-code flow (or the device flow hands the token back to the polling
 * device). The flow is a standalone task, so it ends here - not back at the content page the user
 * came from. Configured to the framework via Koan:Mcp:Auth:DonePath (reserved for when the AS
 * ships).
 */
export function AccountConnectDonePage() {
    return (
        <div class="flex min-h-full flex-col">
            <EmporiumNav current={null} />
            <main class="flex-1">
                <div class="mx-auto max-w-[460px] px-[clamp(20px,4vw,40px)] py-[clamp(28px,4vw,64px)]">
                    <article class="rounded-[14px] border border-rule bg-surface-raised p-[clamp(28px,4vw,44px)] text-center shadow-[0_24px_60px_-32px_rgba(0,0,0,0.6)]">
                        <div class="mb-6 flex flex-col items-center gap-2.5">
                            <img
                                src={versionedUrl('/loporrit-mark-192.png')}
                                alt=""
                                width="64"
                                height="64"
                                class="block h-16 w-16 object-contain drop-shadow-[0_12px_20px_rgba(0,0,0,0.45)]"
                            />
                            <Eyebrow tone="faint">All set</Eyebrow>
                        </div>
                        <SectionHeading
                            title="You're connected"
                            subtitle="The application now has the access you approved. You can close this page and return to it."
                            size="lg"
                            align="center"
                            as="h1"
                            class="mb-6"
                        />
                        <a
                            href={withBase('/me/account')}
                            class="inline-flex w-full items-center justify-center gap-2 rounded-full border border-dashed border-rule-strong px-4 py-2.5 text-[13px] text-fg-muted transition-colors hover:border-fg-muted hover:text-fg-primary"
                        >
                            Go to your account
                        </a>
                    </article>
                </div>
            </main>
            <Colophon emporiumHref="/emporium" studioHref="/studio" packHref={LINKS.github.releasesLatest} />
        </div>
    );
}
